var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowjumping({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.226,
    cy: 27.999,
    fill: "#282828",
    rx: 1.4,
    ry: 1.398
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9D961",
    d: "M32.34 29.78c6.389.239 4.254 17.174 13.462 20.15-12.975 1.32-8.767-16.441-16.82-16.792l3.358-3.358Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7D1AB",
    d: "M12.057 22.91c5.513-.439 9.693-.254 15.503 1.307.712 4.862 1.18 9.721-.177 14.558-3.112.013-7.31 2.52-9.811 4.086l-.898-5.402-7.369 1.316c-2.22-5.202-3.333-7.97-3.337-8.305-.924-.174-1.936-.404-3.038-.69 1.363-2.755 2.267-4.99 2.713-6.706 1.541.107 3.113.077 4.909-.05.062-.004.12-.008.176-.012l.167-.012c.252-.019.54-.041 1.162-.09Zm-5.18-2.4c4.77-2.238 11.359-2.07 20.09-.203.061.408.124.816.186 1.223-5.58-1.39-9.844-1.546-15.295-1.113-.593.047-.878.07-1.12.088l-.237.017c-.04.003-.082.006-.126.009-1.359.096-2.569.133-3.733.092Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M26.901 33.167c.927.958 2.796.656 4.174-.674 1.38-1.33 1.746-3.184.82-4.142-.926-.958-2.795-.657-4.174.673-1.379 1.33-1.746 3.185-.82 4.143Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9D961",
    d: "M24.4 23.47c2.62.527 5.502 1.355 9.003 2.576-.819 2.685-4.488 4.713-7.626 4.713-3.556 0-3.866-2.305-1.766-5.818.208-.5.326-.972.382-1.415Zm1.377-4.346c2.94 0 6.349 1.781 7.44 4.214-3.473-1.174-6.372-1.964-9.044-2.457-.236-1.135-.298-1.757 1.604-1.757Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB5556",
    d: "M28.729 24.543c.503.146 1.02.301 1.55.467-2.841 6.62-7.222 12.266-12.71 15.34-.73-.105-.992-.958-.617-1.638 4.972-2.784 8.894-7.715 11.58-13.718Zm-3.91-23.764c14.062 3.704 16.043 18.43 11.8 23.766-11.148-4.108-16.634-4.773-24.76-4.128-.594.047-.88.07-1.12.088l-.238.017c-.04.003-.082.006-.126.009-3.45.243-5.942.108-9.16-.715-1.483-.83-1.821-2.133.194-4.052 2.324-15.026 14.585-17.309 23.41-14.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24.818.78c14.062 3.703 16.044 18.428 11.801 23.765-2.597-.958-4.887-1.728-6.974-2.338.115-.344.238-.691.365-1.042l.13-.355.131-.358c.067-.18.133-.36.2-.542l.132-.364c1.754-4.873 3.125-10.48-5.785-18.767Z",
    opacity: 0.297
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowjumping);
export default __webpack_public_path__ + "static/media/showjumping.20d9d4907fec24d94ef7c891dcb8f68c.svg";
export { ForwardRef as ReactComponent };